module.exports = __webpack_public_path__ + "img/fiveIm.93c3fa5f.png";